import { actionCreator } from '../../../../store/utils';
import { LOG_IN_USER, LOG_OUT_USER } from './types';

const defaultState = {
  isLoading: false,
  isConnected: false,
  isError: false,
  error: '',
  userName: '',
  password: '',
};

export default function(state = defaultState, action: any) {
  switch (action.type) {
    case actionCreator('req', LOG_IN_USER):
      return { ...state, isLoading: true, isError: false };
    case actionCreator('res', LOG_IN_USER):
      return {
        ...state,
        isError: false,
        isConnected: true,
        isLoading: false,
        userName: action?.data?.userName,
        password: action?.data?.password,
      };
    case actionCreator('fail', LOG_IN_USER):
      return { ...state, isLoading: false, isError: true, error: action.error };
    case actionCreator('init', LOG_IN_USER):
      return defaultState;
    case LOG_OUT_USER:
      return {
        ...defaultState,
      };
    default:
      return state;
  }
}
